<template>
  <div class="login">
    <a
      v-show="!isLoggedIn"
      :href="twitchAuthUrl"
      rel="nofollow"
      role="link"
      title="Authenticate with Twitch"
      class="button button--xl twitch"
      :class="{ 'button--disabled': authenticating }"
    >
      <template v-if="authenticating">
        <font-awesome-icon icon="spinner" spin pull="left"></font-awesome-icon>
        Authenticating...</template
      >
      <template v-else>
        <font-awesome-icon :icon="['fab', 'twitch']" pull="left" /> Login with
        Twitch</template
      >
    </a>

    <span v-show="isLoggedIn">You are logged in</span>

    <alert
      type="error"
      v-if="error"
      :show="error !== undefined"
      :description="error"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'login',
  data() {
    return {
      error: undefined,
      authenticating: false,
    };
  },
  methods: {
    ...mapActions('auth', ['login']),
    async authenticate() {
      this.authenticating = true;
      try {
        await this.login(this.getAccessTokenFromHash());
        this.$gtag.event('login', { method: 'Twitch' });
      } catch (err) {
        this.error = err;
      }

      if (this.authenticating) {
        this.authenticating = false;
        this.error =
          "We're unable to connect to the server. Please try again later";
      }
    },
    getAccessTokenFromHash() {
      const hash = this.$route.hash.match(/#(?:access_token)=([\S\s]*?)&/)[1];
      return hash;
    },
    checkRouteHash() {
      if (this.$route.hash && this.$route.hash.includes('#access_token')) {
        this.authenticate();
      }
    },
  },
  mounted() {
    this.checkRouteHash();
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    twitchAuthUrl() {
      const baseUrl = 'https://id.twitch.tv/oauth2/authorize';
      const clientId = process.env.VUE_APP_TWITCH_CLIENT_ID;
      const redirectUri = process.env.VUE_APP_TWITCH_REDIRECT_URI;
      const forceVerify = process.env.NODE_ENV !== 'production';
      const scopes = 'user_subscriptions';
      return `${baseUrl}?response_type=token&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scopes}&force_verify=${forceVerify}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 32px;
  margin-bottom: 32px;
}
</style>
